import React, { useContext, useState, FC, cloneElement, Children } from "react";
import { PreviewContext } from "../../../helpers";
import { MoreBenefitsSection } from "./MoreBenefitsSection";

export type ToggleMoreBenefitsProps = {
  buttonTextToCollapse: string;
  buttonTextToOpen: string;
  section: string;
};

export const ToggleMoreBenefits: FC<ToggleMoreBenefitsProps> = ({
  buttonTextToCollapse,
  buttonTextToOpen,
  children,
  section,
}) => {
  const previewMode = useContext(PreviewContext);
  const [isOpen, setIsOpen] = useState(false);
  const childContextProps = { isOpen };

  const contextAwareChildren = Children.map(children, child => {
    return React.isValidElement(child) && typeof child.type !== "string"
      ? cloneElement(child, childContextProps)
      : child;
  });

  return previewMode ? (
    <div>{children}</div>
  ) : (
    <MoreBenefitsSection
      buttonTextToCollapse={buttonTextToCollapse}
      buttonTextToOpen={buttonTextToOpen}
      isOpen={isOpen}
      section={section}
      setIsOpen={setIsOpen}
    >
      {contextAwareChildren}
    </MoreBenefitsSection>
  );
};
